import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
// import { environment } from '../../../../environments/environment';
// import { ToastService } from '../../../Services/toast/toast.service';
import { environment } from '../../../../environments/environment.prod';

// const environment : any = 'www.anith.in';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    private userSubject?: BehaviorSubject<any>;
    public user?: Observable<any>;
    loginurl: any;

    constructor(
        private router: Router,
        private http: HttpClient,
        // private toast: ToastService
    ) {
        this.getstoreduserdata();
    }

    getstoreduserdata() {
        if (typeof sessionStorage !== 'undefined') {
            this.userSubject = new BehaviorSubject<any>(sessionStorage.getItem('user'));
            this.user = this.userSubject.asObservable();
        }
    }

    public get userValue() {
        // return this.userSubject.value || {};
        return this.userSubject?.value || undefined
    }

    login(email: string, password: string) {
        // if (role === 'student') {
        //     this.loginurl = `${environment.API_URL}students/login`
        // } else if (role === undefined || role === null || role === 'employee') {
        //     this.loginurl = `${environment.API_URL}employees/login`
        // } else {
        //     this.loginurl = `${environment.API_URL}employees/login`
        // }
        return this.http.post<any>(`${environment.API_URL}users/login`, { email, password }, { headers: {'Access-Control-Allow-Origin': '*'} })
            .pipe(map(user => {
                // store user details and basic auth credentials in local storage to keep user logged in between page refreshes
                // if (user.status === true && user.code === 200) {
                    user.authdata = window.btoa(email + ':' + password);
                    sessionStorage.setItem('user', JSON.stringify(user));
                    this.userSubject = new BehaviorSubject<any>(sessionStorage.getItem('user'));
                    this.getstoreduserdata()
                    // this.toast.showToast(
                    //     'success',
                    //     'Login Successfull!');
                    this.dismissError();
                    return user;
                // } else {
                //     // this.handleError
                //     // this.toast.showToast(
                //     //     'danger',
                //     //     'Something went Worng!');
                //     this.dismissError();
                //     return user;
                // }

            }),
                catchError(this.handleError))
    }

    handleError(errorResponse: HttpErrorResponse) {
        // this.toast.showToast(
        //     'danger',
        //     'Something went Worng !');
        this.dismissError();
        return throwError(errorResponse.message || 'server error');
    }

    logout() {
        sessionStorage.removeItem('user');
        this.userSubject?.next(null!);
        this.getstoreduserdata();
        this.router.navigate(['/login']);
    }
    private dismissError(): void {
        setTimeout(() => {
            // this.toast.dismissToast();
        }, 3000);
    }
}